<template>
    <div class="d-flex flex-fill">
        <div class="container py-3">
            <div class="row justify-content-center h-100">
                <div class="col-sm-12">
                    <div class="d-flex flex-column w-100 h-100">
                        <div class="flex-grow-1">
                            <div v-if="paymentsList.length > 0">
                                <payment-rows
                                    :payments="paymentsList"
                                    :refunds="reservation.refunds"
                                    :reservation="reservation"
                                />
                            </div>

                            <div v-else class="text-center fs-large dark w-100 my-4">
                                No Payments found
                            </div>
                        </div>
                        
                        <label v-if="reservation.isToGeneratePaymentLink || activePaymentLink && enabledStatusStripeIntegration" class="fs-large p-2">Payment Link</label>
                        
                        <div v-if="activePaymentLink && enabledStatusStripeIntegration" class="bg-lighter px-3 py-3 mb-3 mt-1 radius-normal" style="border: 1px solid rgb(197, 208, 222);list-style-type: disc;">
                            <div class="d-flex justify-content-between px-3">
                                <div class="">
                                    <div class="d-flex row">
                                        <span class="mr-4" v-if="activePaymentLink.cancelBookingIfNotPaidAfter">
                                            <strong>Expires:</strong> {{formatDateDots(activePaymentLink.cancelBookingIfNotPaidAfter)}} 
                                            <strong> at </strong><span>{{formatTime(activePaymentLink.cancelBookingIfNotPaidAfter) }}</span>
                                        </span>

                                        <span class="mr-4" v-else>
                                            <strong>Expires:</strong> n/a
                                        </span>

                                        <span class="mr-4"><strong>Notes:</strong> {{activePaymentLink.description}}</span>
                                        <span><strong>Total to pay:</strong> {{formatPriceLink(activePaymentLink.value)}}€</span>
                                    </div>

                                    <div class="d-flex row align-items-center mt-3">
                                        <div class="d-flex flex-column flex-wrap">
                                            <span class="text-break"><strong>Url: </strong>{{activePaymentLink.url}}</span>
                                        </div>
                                    </div>

                                    <div class="d-flex align-items-center mt-3 ml-n3">
                                        <span class="dark border-dark radius-normal align-items-center px-2 py-1 pointer bg-lightest fs-smaller mr-3" @click="copyUrl(activePaymentLink.url)">
                                            <i class="ico ico-notes fs-smaller"></i>
                                            Copy
                                        </span>

                                        <a v-if="hasEmail" href="#" class="color-1 underlined tab-payments__send-link" :class="{ 'tab-payments__send-link--sending': isSendingLink }" @click="isSendingLink ? null : sendLink()">{{isSendingLink ? 'Sending Email' : 'Send Email'}}</a>
                                    </div>
                                </div>

                                <div class="ml-2 d-flex align-items-start">
                                    <button v-if="activePaymentLink.canBeCancelled" class="btn wider action" @click="changeStatusLink()">Cancel</button>
                                </div>                               
                            </div>
                        </div>

                        <div v-else-if="paymentLink && paymentLink.bookingId == 0 && reservation.isToGeneratePaymentLink && enabledStatusStripeIntegration" class="bg-lighter px-3 py-3 mb-3 mt-1 radius-normal" style="border: 1px solid rgb(197, 208, 222);list-style-type: disc;">
                            <div class="d-flex align-items-center justify-content-between">
                                <span class="mr-4" v-if="paymentLink.cancelBookingIfNotPaidAfter">
                                    <strong >Expires:</strong> {{formatDateDots(paymentLink.cancelBookingIfNotPaidAfter)}} 
                                    <strong> at </strong><span>{{formatTime(paymentLink.cancelBookingIfNotPaidAfter) }}</span>
                                </span>

                                <span class="mr-4" v-else><strong>Expires:</strong> n/a</span>
                                <span class="mx-4"><strong>Notes:</strong> {{paymentLink.description ? paymentLink.description : 'n/a'}}</span>
                                <span class="mx-4"><strong>Total to pay:</strong> {{formatPriceLink(paymentLink.value)}}€</span>
                                <span class="mx-4 color-1"><strong>Pending</strong></span>
                                <i @click="reservation.isToGeneratePaymentLink = false" class="fa fa-times fs-large light ml-2 pointer"></i>
                            </div>
                        </div>

                        <div class="d-flex border-top-medium pt-2">
                            <div class="flex-grow-1">
                                <button
                                    :disabled="accessPermissionFilter(['restricted']) || isReservationReadOnly && reservation.status != -5 || !refundsOrPayOutAllowed || disabled"
                                    class="btn wider action"
                                    @click="createRefundBtn()"
                                    v-tooltip="'Customer and Agent (if applied) will receive an email with refund information.'"
                                >
                                    Refund <i class="fas fa-info-circle mr-0 ml-1"></i>
                                </button>
                            </div>

                            <div>
                                <button v-if="!activePaymentLink && !this.reservation.isToGeneratePaymentLink && enabledStatusStripeIntegration" :disabled="isReservationReadOnly && reservation.status != -5 && this.outstandingAmout || disabled" class="btn wider blue" @click="openReservationLinkIn()">Payment Link</button>
                                <button :disabled="isReservationReadOnly && reservation.status != -5 || disabled" class="btn wider green ml-3" @click="openModal('ReservationPayIn')">Pay in</button>
                                <button :disabled="isReservationReadOnly && reservation.status != -5 || !refundsOrPayOutAllowed || disabled" class="btn wider action" @click="openPayOutModal()">Pay out</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { reservationsMixin } from '@/mixins/reservations'

import paymentRows from '@/tools/modal/ReservationEditV2/TabPayments/paymentRows'

export default {
    data() {
        return {
            isSendingLink: false,
        }
    },
    mixins: [
        reservationsMixin,
    ],
    props:{
        reservation: {
            type: Object
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapGetters([
            'getReservationCalculations',
            'getSelectedReservation',
            'getIsLoadingSupplierIntegrations',
            'getSingleIntegration',
            'getAllIntegrations'
        ]),
        hasEmail() {
            return this.reservation.customer.email;
        },
        refundsOrPayOutAllowed() {
            return (this.paymentsList.length > 0 && this.paymentsList.some(p => p.paymentDirection === 0 && p.id !== 0));
        },
        paymentsList() {
            // Sort payments: later is lower
            let payments = [];

            if (this.reservation.billing.payments && this.reservation.billing.payments.length > 0) {
                payments = this.reservation.billing.payments.sort(function(a, b) {
                    return moment(a.date).isAfter(moment(b.date));
                });
            }

            return payments.concat(this.unsavedRefundsList);
        },
        stripeIntegration() {
            if (this.getAllIntegrations.length > 0 && this.getIsLoadingSupplierIntegrations == false) {
                return this.getSingleIntegration(101);
            } else {
                return false;
            }
        },
        enabledStatusStripeIntegration() {
            if (this.stripeIntegration) {
                return this.stripeIntegration.integrationStatus == 1;
            } else {
                return false;
            }
        },
        activePaymentLink() {
            let pendingLink = this.reservation.bookingBillingPaymentLinks.find((link)=>{
                return link.status == 1;
            });

            return pendingLink;
        },
        paymentLink() {
            if (this.reservation.bookingBillingPaymentLink) {
                return this.reservation.bookingBillingPaymentLink;
            }
        },
        unsavedRefundsList() {
            // we need to mask it as a "payemnt" to be shown as one
            let unsavedRefunds = this.reservation.refunds.filter(refund => {
                return !refund.id;
            });

            let refundsMaskedAsPayments = unsavedRefunds.map(refund => {
                return {
                    "id": -1,
                    "date": moment().format('YYYY-MM-DD HH:mm:ss'),
                    "type": -100,
                    "paymentTypeDescription": "Unsave Refund",
                    "value": refund.amountResumeValue,
                    "currency": "€",
                    "paymentDirection": 0,
                    "paymentDirectionDescription": "Pay In",
                    "description": null,
                    "treasurerSupplier": null,
                    "treasurerUserAccount": null,
                    "treasurerChannel": null,
                    "refundId": null,
                    "refundObj": refund,
                    "isVirtualPayment": false
                }
            });

            return refundsMaskedAsPayments;
        },
        hasUnsavedChanges() {
            const updateFlags = this.reservation.updateFlags;
            const hashasUnsavedChanges = Object.values(updateFlags).some(value => value === true);
            
            return hashasUnsavedChanges;
        },
    },
    methods: {
        ...mapActions([
            'openModal',
            'sendPaymentLinkByEmail',
        ]),
        showUnsavedChangesAlert() {
            this.$dialog.alert(
                `<div class="d-flex flex-column justify-content-center">
                    <div class="fs-largest font-weight-600 mb-4">There are unsaved changes!</div>
                    <div class="bold dark">You must save the reservation before rebooking.</div>
                </div>`,
                { okText: 'Yes', cancelText: 'No'}
            );
        },
        openReservationLinkIn() {
            if (this.hasUnsavedChanges) {
                this.showUnsavedChangesAlert();
            } else {
                this.openModal('ReservationLinkIn');
            }
        },
        openPayOutModal() {
            if (this.hasUnsavedChanges) {
                this.showUnsavedChangesAlert();
            } else {
                this.openModal('ReservationPayOut');
            }
        },
        outstandingAmout() {
            return this.getReservationCalculations.grandTotal;
        },
        createRefundBtn() {
            if (this.hasUnsavedChanges) {
                this.showUnsavedChangesAlert();
            } else {
                this.eventHub.$emit('refundReservation');
            }
        },
        changeStatusLink() {
            let pendingLink = this.reservation.bookingBillingPaymentLinks.find((link) => {
                return link.status == 1;
            });
            this.$set(this.getSelectedReservation.updateFlags, 'paymentLink', true);
            pendingLink.status = 3;
        },
        formatPriceLink(price) {
            let rounded = Math.round(price * 100) / 100;
            
            return parseFloat(rounded).toFixed(2);
        },
        copyUrl(url) {
            let urlLink = url;
            this.$clipboard(urlLink);
            this.$toasted.success('Url copied');
        },
        sendLink() {
            if (this.isSendingLink) {
                return;
            }

            this.isSendingLink = true;
            this.$toasted.info(`Sending to ${this.reservation.customer.email}`);

            this.sendPaymentLinkByEmail().then(result => {
                if (result) {
                    this.$toasted.success('Your email has been sent.');
                } else {
                    this.$toasted.error('Something went wrong, please try again later.');
                }
            })
            .catch(error => {
                this.$toasted.error('Something went wrong, please try again later.');
            })
            .finally(() => {
                this.isSendingLink = false;
            });
        },
    },
    components: {
        paymentRows,
    }
}
</script>

<style lang="scss" scoped>
    .tab-payments__send-link--sending {
        opacity: 0.5;
        cursor: not-allowed;
    }
</style>



// WEBPACK FOOTER //
// TabPayments.vue?9c7f26e8